import angular from 'angular';
import MenuDropdownComponent from './menu-dropdown.component';

let MenuDropdownModule = angular.module('shared.components.menuDropdown', [])
  .component('menuDropdown', MenuDropdownComponent);

export default MenuDropdownModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/menu-dropdown/menu-dropdown.js
 **/